// The server of the desktop app (INST, Rust `server_get` / `server_set` in src-tauri/src/lib.rs, settings.rs): release builds
// only, a dev run keeps its VITE_API_URL. `server_set` checks `<server>/api/v1/health/live` unless forced, saves and restarts.
import { invoke } from '@tauri-apps/api/core';
import { isDesktop } from '../platform';

export interface ServerInfo { server: string; built: string; saved: boolean }
/** Whether this build reads its server from the setting (settings.rs sets the value before the page runs). */
export const hasServerSetting = () => isDesktop() && !!(window as { __RIMO_SERVER__?: string }).__RIMO_SERVER__;
export const serverInfo = () => invoke<ServerInfo>('server_get');

/** Saves and restarts the app, so a `null` is rarely seen; else why it was refused. `force`: saved although unreachable. */
export async function saveServer(address: string, force = false): Promise<'invalid' | 'unreachable' | 'failed' | null> {
  try { await invoke('server_set', { server: address.trim(), force }); return null; }
  catch (e) { return e === 'invalid' || e === 'unreachable' ? e : 'failed'; }
}
